import { gql } from "@apollo/client";

export const RESET_PASSWORD = gql`
  mutation ForgotPasswordReset(
    $newPassword: String!
    $newPasswordConfirm: String!
    $signedUserId: String!
    $resetToken: String!
  ) {
    forgotPasswordReset(
      newPassword: $newPassword
      newPasswordConfirm: $newPasswordConfirm
      signedUserId: $signedUserId
      resetToken: $resetToken
    ) {
      success
    }
  }
`;
